export const styles = {
  root: {
    height: '100%',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '18px',
  },
  title: {
    fontWeight: 800,
    fontSize: '32px',
    color: '#1D2943',
    marginBottom: '12px',
  },
  text: {
    fontWeight: 400,
    fontSize: '16px',
    color: ' #011533',
    maxWidth: '560px',
    marginBottom: '34px',
    lineHeight: '20px',
  },
  subtitle: {
    fontWeight: 700,
    fontSize: '24px',
    color: '#1D2943',
    marginBottom: '24px',
  },
  campaignBlock: {
    display: 'flex',
    marginBottom: '34px',
    '& > div:first-child': {
      marginRight: '20px',
    },
  },
  createCampaign: {
    display: 'flex',
    flexDirection: 'column',
  },
  card: {
    width: '588px',
    height: '92px',
    background: '#FFFFFF',
    boxShadow: '0px 2px 14px rgba(39, 55, 84, 0.08)',
    borderRadius: '8px',
    marginBottom: '18px',
    padding: '10px 40px 10px 16px',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  cardTextWrapper: {
    display: 'flex',
    flexDirection: 'column',
    margin: '0 34px 0 12px',
    maxWidth: '460px',
    justifyContent: 'space-between',
  },
  cardLeftBlock: {
    display: 'flex',
    alignItems: 'center',
  },
  cardTitleAndStatusContainer: {
    maxWidth: '50%',
    wordWrap: 'break-word',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    '@media screen and (max-width: 768px)': {
      alignItems: 'center',
      minWidth: '100%',
      display: 'flex',
      flexDirection: 'row',
    },
  },
  cardTitle: {
    fontWeight: 700,
    fontSize: '18px',
    color: '#1D2943',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },
  cardText: {
    fontWeight: 400,
    fontSize: '16px',
    color: ' #011533',
    lineHeight: '20px',
  },
  guideCard: {
    width: '490px',
    background: '#FFFFFF',
    boxShadow: '0px 2px 14px rgba(39, 55, 84, 0.08)',
    borderRadius: '8px',
    padding: '16px 12px 32px',
    display: 'flex',
    '@media screen and (max-width: 768px)': {
      display: 'flex',
      width: '100%',
      flexDirection: 'column',
    },
  },
  svgCampaignIcon: {
    '@media screen and (max-width: 768px)': {
      display: 'none',
    },
  },
  guideIcon: {
    '@media screen and (max-width: 768px)': {
      marginBottom: '24px',
      display: 'flex',
      alignSelf: 'center',
    },
  },
  guideLeftBlock: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  guideTextBlock: {
    maxWidth: '260px',
    marginBottom: '24px',
  },
  guideTitle: {
    fontWeight: 700,
    fontSize: '18px',
    color: '#1D2943',
    lineHeight: '26px',
    marginBottom: '8px',
  },
  recentCampaignCard: {
    width: '100%',
    minHeight: '90px',
    background: '#FFFFFF',
    boxShadow: '0px 2px 14px rgba(39, 55, 84, 0.08)',
    borderRadius: '15px',
    padding: '12px 16px 10px 16px',
    display: 'flex',
    flexDirection: 'column',
    '@media screen and (max-width: 768px)': {
      width: '100%',
      alignItems: 'center',
      gap: '12px',
    },
  },
  recentCampaignTextWrapBlock: {
    display: 'flex',
    alignItems: 'flex-end',
    marginTop: 'auto',
    marginBottom: '0px',
    '@media screen and (max-width: 768px)': {
      width: '100%',
      justifyContent: 'center',
    },
  },
  recentCampaignCTAWrapper: {
    margin: 'auto 0',
  },
  recentCampaignTextBlock: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    '@media screen and (max-width: 768px)': {
      flexDirection: 'row',
      gap: '12px',
    },
  },
  statusWrapper: {
    marginRight: '18px',
    '@media screen and (max-width: 768px)': {
      marginRight: 0,
    },
  },
  recentCampaignCardAction: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    '@media screen and (max-width: 768px)': {
      flexDirection: 'column',
    },
  },
  marginTop10: {
    marginTop: '10px',
    '@media screen and (max-width: 768px)': {
      marginTop: '0',
    },
  },
  loadingWrapper: {
    marginTop: '250px',
  },
  newCampaignCTAOptionsWrapper: {
    width: '208px',
    position: 'absolute',
    background: '#FFFFFF',
    borderRadius: '8px',
    border: '1px solid #2737541F',
    marginTop: '4px',
    '& > p': {
      padding: '13px 10px',
      lineHeight: '18px',
      cursor: 'default',
      color: '#0C172C',
      '&:hover': {
        '&:first-child': {
          borderRadius: '8px 8px 0 0',
        },
        background: '#E2E2FC',
        cursor: 'pointer',
        '&:last-child': {
          borderRadius: '0 0 8px 8px',
        },
      },
    },
    '@media screen and (max-width: 768px)': {
      width: '85%',
    },
  },
}
